export class LabelGroupStyling {
  public includePadding: boolean = true;
  public numberColumns: number = 1;
}
